import React, { useEffect, useState } from "react";
import {
  FaWrench,
  FaBolt,
  FaPaintRoller,
  FaBroom,
  FaHammer,
  FaToolbox,
} from "react-icons/fa";

import "../../../styles/Header-css/ServicePartner/PartnerVerification/SkillsStep.css";
import {
  getSkillCatalog,
  savePartnerSkills,
} from "../../../../api/partner/skills";

/* 🔹 ICON MAP (local for now, backend later) */
const ICON_MAP = {
  "Water Purifier": <FaToolbox />,
  Electrician: <FaBolt />,
  Plumbing: <FaWrench />,
  Maid: <FaBroom />,
  Dailywage: <FaHammer />,
  "Virtual Assistant": <FaPaintRoller />,
};

const SkillsStep = ({ data, onDataChange, onBack, onNext, errors }) => {
  const [categories, setCategories] = useState([]);
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  const [saving, setSaving] = useState(false);
  /* 🔹 Selected state */
  const [selectedCategories, setSelectedCategories] = useState(
    data.selectedCategories || []
  );


  /* 🔹 Load categories on mount */
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const res = await getSkillCatalog();
        setCategories(res);
      } catch (e) {
        console.error("Category load failed", e);
      }
    };
    loadCategories();
  }, []);

  /* 🔹 Sync with parent form */
  useEffect(() => {
    onDataChange({
      target: { name: "selectedCategories", value: selectedCategories },
    });
   
  }, [selectedCategories]);

  /* 🔹 Handle category select / deselect */
  const handleCategoryClick = (category) => {
  const categoryId = category.categoryId;

  setSelectedCategories((prev) => {
    if (prev.includes(categoryId)) {
      // deselect
      return prev.filter((id) => id !== categoryId);
    }
    // select
    return [...prev, categoryId];
  });

  setActiveCategoryId(categoryId);
};



  /* 🔹 Group selected services (for summary UI) */
  const groupSelectedServices = () => {
    const grouped = {};

    selectedCategories.forEach((catId) => {
      const category = categories.find((c) => c.categoryId === catId);
      if (!category) return;

      grouped[category.name] =[category.name];
    });

    return grouped;
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setSaving(true);
    console.log("Saving skills...");

    // Await the save function
    const result = await savePartnerSkills(selectedCategories);
    //onNext();
    console.log("Save result:", result);

    // Check if save succeeded
    if (result.saved > 0) {
       onNext();

      // Update parent formData via onDataChange
      onDataChange({ selectedSkills: selectedCategories });
     
      // Call onNext to move forward
      if (typeof onNext === "function") {
        console.log("Calling onNext...");
       // onNext();
      } else {
        console.error("onNext is not defined or not a function");
      }
    } else {
      alert("Failed to save skill. Please try again.");
    }
  } catch (err) {
    console.error("Skills save failed", err);
    alert("Failed to save skill. Please try again.");
  } finally {
    setSaving(false);
  }
};

  // const handleSubmit = async(e) => {
  //   e.preventDefault();
  //   if (selectedCategories.length === 0) {
  //     alert("Please select at least one service");
  //     return;
  //   }
  //    try {
  //         setSaving(true);
  //         await savePartnerSkills(selectedCategories);
  //         onNext();
  //       } catch (err) {
  //         console.error("Skills save failed", err);
  //         alert("Failed to save skill. Please try again.");
  //       } finally {
  //         setSaving(false);
  //       }
  //  // onNext();
  // };

  return (
    <>
      <h2>Select Services</h2>

      <div className="onboarding-card">
        <h3>Select Services</h3>
        <p>Select services you want to provide</p>
      </div>

      <form onSubmit={handleSubmit}>
        {/* 🔹 CATEGORY GRID */}
        <div className="onboarding-skills-grid">
          {categories.map((cat) => (
            <div
              key={cat.categoryId}
              className={`onboarding-skill-card ${
                selectedCategories.includes(cat.categoryId) ? "selected" : ""
              }`}
              onClick={() => handleCategoryClick(cat)}
            >
              <div className="onboarding-skill-icon">
                {ICON_MAP[cat.name] || <FaToolbox />}
              </div>
              <div className="onboarding-skill-label">{cat.name}</div>
            </div>
          ))}
        </div>

       

        {/* 🔹 SELECTED SERVICES SUMMARY (MATCHES OLD STATIC DESIGN) */}
        {selectedCategories.length > 0 && (
          <div className="onboarding-selected-skills">
            <h4>Selected Services:</h4>
     {Object.entries(groupSelectedServices()).map(
              ([category, items]) => (
                <div key={category} className="selected-category-block">
                  <h5 className="selected-category-title">{category}</h5>
     <div className="onboarding-selected-skills-list">
                    {items.map((item) => (
                      <div
                        key={item}
                        className="onboarding-selected-skill-chip">
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}
          </div>
        )}

        {/* 🔹 FOOTER BUTTONS */}
        <div className="onboarding-button-group">
          <button
            type="button"
            onClick={onBack}
            className="onboarding-btn onboarding-btn-secondary"
          >
            Back
          </button>
          <button
            type="submit"
            className="onboarding-btn onboarding-btn-primary"
          >
            Submit
          </button>
        </div>
      </form>
    </>
  );
};

export default SkillsStep;
